/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainStoreStoreProductLabels interface.
 */
export function instanceOfFxIdDomainStoreStoreProductLabels(value) {
    if (!('Labels' in value) || value['Labels'] === undefined)
        return false;
    return true;
}
export function FxIdDomainStoreStoreProductLabelsFromJSON(json) {
    return FxIdDomainStoreStoreProductLabelsFromJSONTyped(json, false);
}
export function FxIdDomainStoreStoreProductLabelsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Labels': json['Labels'],
    };
}
export function FxIdDomainStoreStoreProductLabelsToJSON(json) {
    return FxIdDomainStoreStoreProductLabelsToJSONTyped(json, false);
}
export function FxIdDomainStoreStoreProductLabelsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Labels': value['Labels'],
    };
}
//# sourceMappingURL=FxIdDomainStoreStoreProductLabels.js.map